import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useHistory, useParams} from 'react-router-dom'
import {RootState} from '../../../../../setup'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import {Button} from '@mui/material'
import axios from 'axios'
import {
  PHYSICAL_THERAPIST_LISTING_COLOUMS,
  PHYSICAL_THERAPIST_DATA_MAPPING,
  PHYSICAL_THERAPIST_SORTING_DATA,
} from '../../../Notes/Physical_Therapist_Notes/PHYSICAL_THERAPIST_TABLE_CONSTANT'
import {toast} from 'react-toastify'
import {MoonLoader} from 'react-spinners'
import dayjs from 'dayjs'

const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const DeletedPhysicalTherapistNotesList = () => {
  const [filteredData, setFilteredData] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [isFetchingData, setIsFetchingData] = useState(true)
  const [loadingStates, setLoadingStates] = useState({})
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId
  const timeZone = useSelector(selectTimeZone)
  const params: {id: string} = useParams()
  const history = useHistory()
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })

  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string) => {
      setIsFetchingData(true)
      try {
        if (!params.id) {
          console.error('Client ID is missing')
          return
        }

        const response = await axios.get(
          `/physical-notes/filterByClient/${params.id}?isDeleted=true`,
          {
            params: {
              page: page,
              pageSize: pageSize,
              sortBy: sortBy,
              sortDir: sortDir,
              searchTerm: queryData.searchTerm,
            },
          }
        )
        const {data, currentPage, totalCounts} = response.data
        const updatedData = data.map((item) => ({
          ...item,
          startDate: item?.startDate
            ? dayjs.utc(item.startDate).tz(timeZone, true).format('MM-DD-YYYY')
            : 'No details provided',
        }))
        setFilteredData(updatedData)
        setQueryData((prevState) => {
          return {
            ...prevState,
            currentPage,
            totalCounts,
          }
        })
      } catch (error) {
        console.error('Error fetching deleted physical therapy notes:', error)
        toast.error('Error fetching deleted physical therapy notes')
      } finally {
        setIsFetchingData(false)
      }
    }

    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  }, [
    queryData.pageNumber,
    queryData.pageSize,
    queryData.sortBy,
    queryData.sortDir,
    queryData.searchTerm,
  ])

  const handleUpdate = (row: any) => {
    history.push(`/deleted-notes/physical-therapist-notes/notesEntries/entry/${row._id}`)
  }

  const handleView = (row: any) => {
    history.push(`/deleted-notes/physical-therapist-notes/notesEntries/entry/${row._id}`)
  }

  if (isFetchingData) {
    return (
      <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
        <MoonLoader color='#9db2fc' size={60} loading={isFetchingData} />
      </div>
    )
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <div>
          <TableTitle title='Deleted Physical Therapist Notes' />
          <TableWrapper
            searchField={
              <TableSearchBar
                label='Search'
                variant='outlined'
                size='small'
                value={searchTerm}
                setQueryData={setQueryData}
                setSearchTerm={setSearchTerm}
                margin='normal'
                inputAdornmentPosition='start'
              />
            }
            tableButtons={
              <Button variant='contained' color='primary' onClick={() => history.goBack()}>
                Back
              </Button>
            }
            dynamicTable={
              <DynamicTable
                columns={PHYSICAL_THERAPIST_LISTING_COLOUMS}
                data={filteredData}
                canUpdate={true}
                onUpdate={handleUpdate}
                columnDataMapping={PHYSICAL_THERAPIST_DATA_MAPPING}
                sortingColumns={PHYSICAL_THERAPIST_SORTING_DATA}
                clickableRow={false}
                loadingStates={loadingStates}
                setQueryData={setQueryData}
                queryData={queryData}
                title='View deleted physical therapy note'
              />
            }
          />
        </div>
      </div>
    </div>
  )
}

export default DeletedPhysicalTherapistNotesList
